import { render } from "./WuCaiGouShenPiDetail.vue?vue&type=template&id=70879a21"
import script from "./WuCaiGouShenPiDetail.vue?vue&type=script&lang=js"
export * from "./WuCaiGouShenPiDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__